<template>
  <v-card outlined>
    <v-card-title v-if="showTitle"> Replace Templates </v-card-title>
    <v-data-table
      v-model="selected"
      :items="list"
      :headers="headers"
      multi-sort
      :loading="loading"
      :search="filter.search"
      :footer-props="{
        'items-per-page-options': [100, 250, 500, 1000]
      }"
      mobile-breakpoint="0"
      class="row-pointer"
      item-key="id"
      @click:row="editTemplate"
    >
      <template #[`header.published`]="{}">
        <v-icon small> wifi </v-icon>
      </template>

      <template #[`item.published`]="{ item }">
        <v-icon
          small
          :color="item.published ? 'success' : 'error'"
        >
          wifi
        </v-icon>
      </template>
      <template #[`item.imageFlatSide1Thumb`]="{ item }">
        <v-img
          v-if="item.imageFlatSide1Thumb"
          :src="item.imageFlatSide1Thumb"
          width="100"
          contain
          class="my-1"
        />
      </template>
      <template #[`item.imageFlatSide2Thumb`]="{ item }">
        <v-img
          v-if="item.imageFlatSide2Thumb"
          :src="item.imageFlatSide2Thumb"
          width="100"
          contain
          class="my-1"
        />
      </template>
      <template #[`item.hasItemPage`]="{ item }">
        <v-icon
          v-if="item.hasItemPage"
          small
          color="success"
        >
          check_circle
        </v-icon>
      </template>
      <template #[`item.designGroup.designNotes`]="{ item }">
        <v-icon
          v-if="item.designGroup.designNotes"
          small
          color="success"
        >
          check_circle
        </v-icon>
      </template>
      <template #[`item.modifiedDate`]="{ item }">
        {{ item.modifiedDate | normalDateWithTime }}
      </template>
      <template #[`item.actions`]="{}">
        <v-icon>more_vert</v-icon>
      </template>
    </v-data-table>
    <TemplatesEdit @reload="loadData" />
  </v-card>
</template>

<script>
import TemplatesEdit from '@/components/templates/Edit';
import { mapGetters } from 'vuex';
export default {
  name: 'ReplaceTemplates',
  components: { TemplatesEdit },
  props: { showTitle: { type: Boolean, default: false } },
  data: () => {
    return {
      headers: [
        { value: 'published' },
        { value: 'imageFlatSide1Thumb' },
        { value: 'imageFlatSide2Thumb' },
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Editor Opens', value: 'editorOpens' },
        { text: 'Score', value: 'score' },
        { text: 'Group', value: 'designGroup.nameHierarchy' },
        { text: 'Item Page', value: 'hasItemPage' },
        { text: 'Brief', value: 'designGroup.designNotes' },
        {
          text: 'Modified',
          value: 'modifiedDate'
        },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters['catalog/filter'];
      },
      set(val) {
        this.$store.dispatch('catalog/filter', val);
      }
    },
    selected: {
      get() {
        return this.$store.getters['catalog/selected'];
      },
      set(val) {
        this.$store.dispatch('catalog/setSelected', val);
      }
    },
    ...mapGetters({
      list: 'templates/replace'
    })
  },
  mounted() {
    this.selected = [];
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$store
        .dispatch('templates/loadReplace', this.filter)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editTemplate(template) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.EDIT_TEMPLATE_SHOW, {
        id: template.id
      });
    }
  }
};
</script>
